import video from './videoPlayerReducer';
import header from './headerReducer';

export const allReducers = {
  video,
  header
};
